import { FC } from "react";

interface ActionButtonProps {
    icon: React.FC<React.SVGProps<SVGSVGElement>>
    onClick?: (e?: React.MouseEvent) => void
    title?: string
}

export const ActionButton: FC<ActionButtonProps> = ({ onClick, icon: Icon, title }) => {
    return (
        <button
            onClick={onClick}
            title={title}
            className="border w-8 h-8 transition hover:bg-black/5 border-color-dark flex items-center justify-center rounded-full"
        >
            <Icon width={20} height={20} />
        </button>
    )
}